import React from 'react';
import Header from '../components/Header';
import AboutSection from '../components/AboutSection';
import CompanyOverviewSection from '../components/CompanyOverviewSection';
import ServicesSection from '../components/ServicesSection';
import TeamSection from '../components/TeamSection';
import GallerySection from '../components/GallerySection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <AboutSection />
        <CompanyOverviewSection />
        <ServicesSection />
        <TeamSection />
        <GallerySection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;